import React, {useState} from 'react';
import './RoomGallery.css';
import ImageModal from './ImageModal';

const RoomGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);  
    const handleImageClick = (index) => {
      setSelectedImage(index);
    };
  
    const handleCloseModal = () => {
      setSelectedImage(null);
    };
  return (
    <>
    <div className="room-gallery">
        {images.map((element, index) => (
          <div key={index} className="room-gallery-item">
            <img 
              src={element.url} 
              alt={"room"}
              className="room-gallery-image"
              onClick={()=>handleImageClick(index)}
            />
            
          </div>
          
        ))}
       
    </div>
    <div 
      className="see-images-btn"
      onClick={()=>handleImageClick(0)}

    >
      <span className="material-symbols-outlined notranslate">photo_library</span>
            <p>See all photos</p>
    </div>

    {selectedImage !== null && (
        <ImageModal
          images={images}
          currentIndex={selectedImage}
          onClose={handleCloseModal}
        />   
      )}
    </>
  );
};

export default RoomGallery;